(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('video-gallery')) return;

    class VideoGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.querySelectorAll('[data-ugc-item]'));
        this.autoplay = this.dataset.autoplay === 'true';

        this.items.forEach((item) => {
          item.addEventListener('click', () => this.toggle(item));
        });

        if (this.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const item = entry.target;
              if (item.classList.contains('is-playing')) return;
              const video = item.querySelector('video');
              if (entry.isIntersecting) {
                video.muted = true;
                video.play().then(() => item.classList.add('is-preview')).catch(() => {});
              } else {
                video.pause();
                item.classList.remove('is-preview');
              }
            });
          }, { threshold: 0.4 });
          this.items.forEach((item) => io.observe(item));
        }

        // Navigation arrows only when there are more videos than fit
        const nav = this.querySelector('[data-ugc-nav]');
        const updateNav = () => {
          const overflow = this.track.scrollWidth > this.track.clientWidth + 4;
          nav.hidden = !overflow;
          this.track.classList.toggle('is-centered', !overflow);
        };
        updateNav();
        window.addEventListener('resize', updateNav);
        const step = () => (this.items[0] ? this.items[0].getBoundingClientRect().width + 20 : this.track.clientWidth);
        nav.querySelector('[data-prev]').addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        nav.querySelector('[data-next]').addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      }

      toggle(item) {
        const video = item.querySelector('video');
        if (item.classList.contains('is-playing')) {
          video.pause();
          item.classList.remove('is-playing');
          return;
        }
        // Stop every other video on the page that plays with sound
        document.querySelectorAll('[data-ugc-item].is-playing').forEach((other) => {
          other.classList.remove('is-playing');
          const v = other.querySelector('video');
          v.pause();
          v.muted = true;
        });
        item.classList.remove('is-preview');
        item.classList.add('is-playing');
        video.muted = false;
        video.currentTime = 0;
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
      }
    }

    customElements.define('video-gallery', VideoGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
